import { EnvironmentCopyPageState } from ".";

export const EnvironmentCopyPageInitialState: EnvironmentCopyPageState = {
  isSaved: false,
  isEdited: false,
  isDplyInPrgrss: false,
  searchResult: {
    envCopyIfDfnCnvRules: [],
    envCopyCpntAttrCnvRules: [],
    environmentCopyRequests: [],
  },
  ifSpreadsheetSelectedRowIndex: 0,
  cpntSpreadsheetSelectedRowIndex: 0,
  dipByRgnDropdown: [],
  dipEnvrnmntSttMngList: [],
  ifItmList: [],
  cpntAttrDropdown: [],
  generalCodes: [],
  cpntIdDropdown: [],
  searchConditions: {
    dipByRgnSelected: undefined,
    copyFromSelected: undefined,
    copyToSelected: undefined,
  },
};
